(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/dialog-contextual/assets/javascripts/dialog-contextual.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/dialog-contextual/assets/javascripts/dialog-contextual.js');
"use strict";


const _svs$ui = svs.ui,
  ReactIcon = _svs$ui.ReactIcon,
  ReactIconButton = _svs$ui.ReactIconButton;
const _svs$components$dialo = svs.components.dialog,
  Contextual = _svs$components$dialo.Contextual,
  TEXT = _svs$components$dialo.TEXT;
const DialogContextual = _ref => {
  let ariaLabel = _ref.ariaLabel,
    dialog = _ref.dialog;
  const showDialog = event => {
    svs.components.dialog.api.add(new Contextual({
      area: svs.components.dialog.area.CONTEXTUAL,
      branding: svs.components.dialog.branding.SPORT,
      attachTo: event.currentTarget,
      title: '',
      message: [{
        type: TEXT,
        text: dialog
      }]
    }));
  };
  return React.createElement(ReactIconButton, {
    "aria-haspopup": "dialog",
    "aria-label": ariaLabel,
    onClick: e => showDialog(e)
  }, React.createElement(ReactIcon, {
    color: "icon-inverted",
    icon: "help"
  }));
};
setGlobal('svs.poker_react.components.DialogContextual', DialogContextual);

 })(window);